import type { ReactNode } from 'react';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3500, { U3500ROLES } from './U3500';
import U3500DocumentSearchList from './components/U3500DocumentSearchList';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3500Routes: RouteObject[] = [
  {
    path: 'U3500',
    element: <U2000RequireRole allowedRoles={[U3500ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3500 />,
        children: [{ index: true, element: <U3500DocumentSearchList /> }],
      },
    ],
  },
];

export default U3500Routes;
